import React from 'react';

import { Tooltip, Switch } from '../../../../components/general';

import { File } from '../../../../types';
import { isEmpty } from '../../../../utils';

interface Props {
  clips: File[];
  lowScoreClips: File[];
  isShowLowScore: boolean;
  toggleShowLowScoreClips: () => void;
}

const PersonClipsHeading: React.FC<Props> = (props) => {
  const { clips, lowScoreClips, isShowLowScore, toggleShowLowScoreClips } =
    props;

  return (
    <div className="flex flex-col sm:flex-row justify-between gap-4 mb-3">
      <h5>
        {isEmpty(clips)
          ? 'No available clips'
          : `Available clips (${clips.length})`}
      </h5>

      {!isEmpty(lowScoreClips) && (
        <div className="flex items-center gap-2">
          <div className="text-sm">Show low-score clips:</div>

          <Tooltip
            text="Low-score clips may not feature the person clearly, but you can still view and select them"
            className="leading-[0]"
          >
            <Switch
              checked={isShowLowScore}
              onChange={toggleShowLowScoreClips}
              size="sm"
            />
          </Tooltip>
        </div>
      )}
    </div>
  );
};

export default PersonClipsHeading;
